import type { ProductionRun } from "./models";
import { currentSupervisorIssue, type SupervisorRunState } from "./supervisor-workspace";
import { withoutUnstartedPlanDuplicates } from "./plan-flow-reporting";
import { operationalShiftAt } from "../../../shared/production/plan-window";

const calendarDate = (value: string | null) => {
  const timestamp = Date.parse(value ?? "");
  return Number.isFinite(timestamp) ? operationalShiftAt(timestamp).date : null;
};

export function supervisorMonitoringState(run: ProductionRun): SupervisorRunState {
  if (run.disposition === "CANCELLED") return { code: "CANCELLED", label: "İptal edildi", priority: 9, tone: "neutral", needsDecision: false };
  if (run.status === "COMPLETED") {
    const issue = currentSupervisorIssue(run);
    if ((issue && issue.status !== "RESOLVED") || run.complaints.some(item => !item.reviewedAt)) return { code: "SUPERVISOR_DECISION", label: "Tamamlandı · Açık bildirim", priority: 2, tone: "decision", needsDecision: true };
    return { code: "COMPLETED", label: "Tamamlandı", priority: 8, tone: "neutral", needsDecision: false };
  }
  if (run.status === "ACTIVE" && run.downtimes.some(item => !item.endedAt)) return { code: "CRITICAL_STOP", label: "Duruşta", priority: 0, tone: "critical", needsDecision: true };
  if (run.disposition === "ON_HOLD" && run.closeNote !== "PLAN_WINDOW_EXPIRED") return { code: "ON_HOLD", label: "Beklemeye alındı", priority: 1, tone: "decision", needsDecision: true };
  const issue = currentSupervisorIssue(run);
  if ((issue && issue.status !== "RESOLVED") || run.complaints.some(item => !item.reviewedAt)) return { code: "SUPERVISOR_DECISION", label: "Takip gereken bildirim", priority: 2, tone: "decision", needsDecision: true };
  if (run.status === "ACTIVE") return { code: "PRODUCTION", label: "Üretimde", priority: 4, tone: "working", needsDecision: false };
  return { code: "WAITING_PLAN", label: "Operatör başlatacak", priority: 5, tone: "neutral", needsDecision: false };
}

/** Daily jobs plus open operational exceptions; plan hours never create an exception. */
export function supervisorMonitoringRuns(runs: ProductionRun[], date: string) {
  const relevant = runs.filter(run => run.planItemKind !== "ACTIVITY" && run.disposition !== "CANCELLED")
    .filter(run => run.shiftDate === date || calendarDate(run.startedAt) === date || calendarDate(run.closedAt) === date ||
      run.status === "ACTIVE" || (run.disposition === "ON_HOLD" && run.closeNote !== "PLAN_WINDOW_EXPIRED") ||
      run.complaints.some(item => !item.reviewedAt) || Boolean(currentSupervisorIssue(run) && currentSupervisorIssue(run)?.status !== "RESOLVED"));
  return withoutUnstartedPlanDuplicates(relevant)
    .sort((a, b) => supervisorMonitoringState(a).priority - supervisorMonitoringState(b).priority ||
      (b.startedAt ?? b.shiftDate).localeCompare(a.startedAt ?? a.shiftDate) || a.id.localeCompare(b.id));
}
